module.exports = "<div class=\"buttons\">\r\n    <button class=\"btn btn-primary start\" (click)=\"onStart()\">Start</button>\r\n    <button class=\"btn btn-danger stop\" (click)=\"onStop()\">Stop</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/assigment-cmp-databinding/game-control/game-control.component.html
// module id = ./src/app/components/assigment-cmp-databinding/game-control/game-control.component.html
// module chunks = main